/**
 * Records in-app route changes (SPA navigation) for issue reports.
 * Stored in sessionStorage so it reflects the current tab session.
 */

const STORAGE_KEY = 'pi-schedule-app-nav-history';
const MAX_ENTRIES = 100;

export function recordNavigation(pathname, search = '') {
    try {
        const path = `${pathname || ''}${search || ''}`;
        const entry = { t: new Date().toISOString(), path };
        const raw = sessionStorage.getItem(STORAGE_KEY);
        let list = [];
        if (raw) {
            try {
                list = JSON.parse(raw);
                if (!Array.isArray(list)) list = [];
            } catch {
                list = [];
            }
        }
        const last = list[list.length - 1];
        if (last && last.path === path) {
            return;
        }
        list.push(entry);
        if (list.length > MAX_ENTRIES) {
            list = list.slice(-MAX_ENTRIES);
        }
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch {
        /* ignore quota / privacy errors */
    }
}

export function getNavigationHistory() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const list = JSON.parse(raw);
        return Array.isArray(list) ? list : [];
    } catch {
        return [];
    }
}
